/**
 * Galaxy-specific navigation configuration
 */
import {
  BarChart3,
  Building2,
  Database,
  Home,
  FileText,
  Radar,
  EyeOff,
  Heart,
  TrendingUp,
  Info,
  Eye,
  Sparkles,
  Cpu,
  Orbit,
  Compass,
  Activity,
  Map,
  Scale,
  Globe,
  Search,
  Skull,
} from "lucide-react";

export const navGroupsByGalaxy = {
  consciousness: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "c-dashboard", label: "Dashboard", icon: Home },
    ]},
    { label: "Discover", items: [
      { id: "c-possibility", label: "Possibility Engine", icon: Sparkles },
      { id: "c-compare", label: "Compare", icon: Globe },
      { id: "c-regional", label: "Regional Explorer", icon: Globe },
      { id: "c-industries", label: "Industries", icon: TrendingUp },
      { id: "c-futures", label: "Industry Futures", icon: Compass },
      { id: "c-trends", label: "Trends & S-Curve", icon: TrendingUp },
      { id: "constellation", label: "Constellation", icon: Sparkles },
      { id: "c-equity", label: "Equity & Impact", icon: Heart },
      { id: "mirror", label: "The Mirror", icon: Eye },
      { id: "insights", label: "Ask the Data", icon: Radar },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-apps", label: "AI Apps", icon: Database, galaxy: "apps" },
      { id: "go-hardware", label: "Physical AI", icon: Cpu, galaxy: "hardware" },
      { id: "go-companies", label: "Companies", icon: TrendingUp, galaxy: "companies" },
      { id: "go-policy", label: "Policy", icon: FileText, galaxy: "policy" },
      { id: "go-research", label: "Research", icon: Radar, galaxy: "research" },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About Us", icon: Info },
      { id: "contribute", label: "Contribute", icon: Heart },
    ]},
  ],
  apps: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "dashboard", label: "Dashboard", icon: Home },
    ]},
    { label: "Explore", items: [
      { id: "regional", label: "Regional Explorer", icon: Globe },
      { id: "compare", label: "Compare", icon: Globe },
      { id: "care-anatomy", label: "Care Anatomy", icon: Heart },
      { id: "utility-anatomy", label: "Utility Anatomy", icon: Database },
      { id: "creative-anatomy", label: "Creative Anatomy", icon: Sparkles },
      { id: "extraction", label: "Extraction Anatomy", icon: Skull },
      { id: "trends", label: "Industry Trends", icon: TrendingUp },
      { id: "explorer", label: "Data Explorer", icon: Database },
    ]},
    { label: "Discover", items: [
      { id: "mirror", label: "The Mirror", icon: Eye },
      { id: "insights", label: "Ask the Data", icon: Radar },
    ]},
    { label: "Research Corner", items: [
      { id: "blind-coding", label: "Blind Coding", icon: EyeOff },
      { id: "research", label: "Research Mode", icon: FileText },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-consciousness-from-apps", label: "Universe", icon: Orbit, galaxy: "consciousness" },
      { id: "go-apps-from-apps", label: "AI Apps", icon: Database, galaxy: "apps", current: true },
      { id: "go-hardware-from-apps", label: "Physical AI", icon: Cpu, galaxy: "hardware" },
      { id: "go-companies-apps", label: "Companies", icon: TrendingUp, galaxy: "companies" },
      { id: "go-policy-apps", label: "Policy", icon: FileText, galaxy: "policy" },
      { id: "go-research-apps", label: "Research", icon: Radar, galaxy: "research" },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About Us", icon: Info },
      { id: "contribute", label: "Contribute", icon: Heart },
    ]},
  ],
  hardware: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "hw-dashboard", label: "Dashboard", icon: Home },
    ]},
    { label: "Explore", items: [
      { id: "hw-regional", label: "Regional Explorer", icon: Globe },
      { id: "hw-compare", label: "Compare", icon: Globe },
      { id: "hw-anatomy", label: "The Embodied", icon: Cpu },
      { id: "hw-care", label: "Care Devices", icon: Heart },
      { id: "hw-utility", label: "Utility Devices", icon: Database },
      { id: "hw-creative", label: "Creative Devices", icon: Sparkles },
      { id: "hw-extraction", label: "Extraction Devices", icon: Skull },
      { id: "hw-trends", label: "Device Trends", icon: TrendingUp },
      { id: "hw-explorer", label: "Device Explorer", icon: Database },
    ]},
    { label: "Discover", items: [
      { id: "hw-insights", label: "Ask the Data", icon: Radar },
    ]},
    { label: "Research Corner", items: [
      { id: "hw-research", label: "Research Mode", icon: FileText },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-consciousness", label: "Universe", icon: Orbit, galaxy: "consciousness" },
      { id: "go-hardware-from-hw", label: "Physical AI", icon: Cpu, galaxy: "hardware", current: true },
      { id: "go-apps-from-hw", label: "AI Apps", icon: Database, galaxy: "apps" },
      { id: "go-companies-hw", label: "Companies", icon: TrendingUp, galaxy: "companies" },
      { id: "go-policy-hw", label: "Policy", icon: FileText, galaxy: "policy" },
      { id: "go-research-hw", label: "Research", icon: Radar, galaxy: "research" },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About", icon: Info },
      { id: "contribute", label: "Submit Device", icon: Heart },
    ]},
  ],
  research: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "r-dashboard", label: "Dashboard", icon: Home },
    ]},
    { label: "Explore", items: [
      { id: "r-explorer", label: "Paper Explorer", icon: Database },
      { id: "r-fields", label: "Research Landscape", icon: Radar },
      { id: "r-gap", label: "Gap Analysis", icon: TrendingUp },
      { id: "r-pulse", label: "Research Pulse", icon: Activity },
      { id: "r-trends", label: "Trends Radar", icon: Radar },
      { id: "r-policy", label: "Policy Influence", icon: Scale },
      { id: "r-geo", label: "Geo Intelligence", icon: Map },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-consciousness-from-r", label: "Universe", icon: Orbit, galaxy: "consciousness" },
      { id: "go-apps-from-r", label: "AI Apps", icon: Database, galaxy: "apps" },
      { id: "go-hardware-from-r", label: "Physical AI", icon: Cpu, galaxy: "hardware" },
      { id: "go-research-from-r", label: "Research", icon: Radar, galaxy: "research", current: true },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About", icon: Info },
      { id: "contribute", label: "Contribute", icon: Heart },
    ]},
  ],
  companies: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "co-dashboard", label: "Dashboard", icon: Home },
      { id: "co-database", label: "Company Database", icon: Search },
      { id: "co-solutions", label: "AI Solutions", icon: Compass },
      { id: "co-products", label: "Product Explorer", icon: Database },
      { id: "co-compare", label: "Compare", icon: BarChart3 },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-consciousness-from-co", label: "Universe", icon: Orbit, galaxy: "consciousness" },
      { id: "go-apps-from-co", label: "AI Apps", icon: Database, galaxy: "apps" },
      { id: "go-hardware-from-co", label: "Physical AI", icon: Cpu, galaxy: "hardware" },
      { id: "go-companies-from-co", label: "Companies", icon: TrendingUp, galaxy: "companies", current: true },
      { id: "go-research-from-co", label: "Research", icon: Radar, galaxy: "research" },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About", icon: Info },
      { id: "contribute", label: "Contribute", icon: Heart },
    ]},
  ],
  policy: [
    { label: null, items: [
      { id: "homepage", label: "Homepage", icon: Orbit, homepage: true },
      { id: "po-dashboard", label: "Dashboard", icon: Home },
    ]},
    { label: "Explore", items: [
      { id: "po-explorer", label: "Policy Explorer", icon: Database },
      { id: "po-readiness", label: "Readiness Index", icon: Activity },
      { id: "po-regional", label: "Regional View", icon: Globe },
      { id: "po-compare", label: "Country Compare", icon: BarChart3 },
      { id: "po-corporate", label: "Corporate Lens", icon: Building2 },
      { id: "po-timeline", label: "Timeline", icon: TrendingUp },
    ]},
    { label: "Explore Galaxies", items: [
      { id: "go-consciousness-from-po", label: "Universe", icon: Orbit, galaxy: "consciousness" },
      { id: "go-apps-from-po", label: "AI Apps", icon: Database, galaxy: "apps" },
      { id: "go-hardware-from-po", label: "Physical AI", icon: Cpu, galaxy: "hardware" },
      { id: "go-companies-from-po", label: "Companies", icon: TrendingUp, galaxy: "companies" },
      { id: "go-policy-from-po", label: "Policy", icon: FileText, galaxy: "policy", current: true },
      { id: "go-research-from-po", label: "Research", icon: Radar, galaxy: "research" },
    ]},
    { label: "Engage", items: [
      { id: "about", label: "About", icon: Info },
      { id: "contribute", label: "Contribute", icon: Heart },
    ]},
  ],
};

/** Hint dot IDs that should pulse on sidebar items */
export const HINT_DOT_IDS = ["c-compare", "c-possibility", "c-industries", "constellation", "mirror", "compare", "hw-compare"];
